export enum MerchantPaymentsStatsType {
  'IN' = 'IN',
  'OUT' = 'OUT'
}
